<template>
  <div class="row">
    <div class="col-md-12">
      <form>
        <card>
          <div slot="header">
            <h4 class="card-title">GAA管理員帳密設定</h4>
          </div>
          <div>
            <fg-input
              label="名稱"
              required
              v-model="model.name"
              v-validate="modelValidations.name"
              :error="getError('full name')"
              name="full name"
            ></fg-input>

            <fg-input
              label="Email address"
              required
              v-model="model.email"
              v-validate="modelValidations.email"
              :error="getError('email')"
              name="email"
              type="email"
            ></fg-input>

            <fg-input
              label="Passowrd"
              required
              name="password"
              v-model="model.password"
              v-validate="modelValidations.password"
              :error="getError('password')"
              type="password"
            ></fg-input>

            <!-- 增加建立帳號的角色，0為一般用戶，1為管理員             -->
            <div class="checkbox-radios">
              <radio
                label="0"
                v-model="model.roleId"
              inline
              >一般帳戶</radio>
              <radio
                label="1"
                v-model="model.roleId"
              inline
              >管理員</radio>
            </div>
            

            <!-- <div class="col-sm-10 checkbox-radios">
              <radio label="ubereats" v-model="model.roleId">Ubereats Pro (上傳菜單+訂單)</radio>
            </div> -->

          </div>
          <div class="d-flex justify-content-center">
            <n-button native-type="submit" @click.native.prevent="validate" type="primary">送出管理員資料</n-button>
          </div>
        </card>
      </form>

      <!-- small modal -->
      <modal
        :show.sync="modals.mini"
        class="modal-danger"
        :show-close="false"
        headerClasses="justify-content-center"
        type="mini"
      >
        <div slot="header" class="modal-profile">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </div>
        <p>
          <strong>{{modals.content}}</strong>
        </p>
        <template slot="footer">
          <!-- <n-button type="neutral" link>Back</n-button> -->
          <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Validator } from 'vee-validate';
import { Checkbox, Radio } from "src/components/index";
import { Modal } from "src/components";
// import CryptoJS from "crypto-js";

Validator.extend('passwordCustom', {
  getMessage: `密碼長度應至少8 碼以上，並且混合大小寫英文字母、數字及特殊符號`,
  validate: value => validatePassword(value)
});

function validatePassword(password) {
  if (password && password.length < 8) return false;
  // 條件1: 包含英文字母和數字
  const cond1 = /(?=.*[a-zA-Z])(?=.*\d)/.test(password);
  // 條件2: 包含英文字母大小寫
  const cond2 = /(?=.*[a-z])(?=.*[A-Z])/.test(password);
  // 條件3: 包含符號
  const cond3 = /(?=.*[\W_])/.test(password);

  const passedConditions = [cond1, cond2, cond3].filter(Boolean).length;

  return passedConditions >= 2;
}

export default {
  components: {
    Checkbox,
    Radio,
    Modal
  },
  // computed: {
  //   userId: function() {
  //     console.log("the user Id is ", this.$store.getters.userId);
  //     // Encrypt 加密
  //     // var cipherText = CryptoJS.AES.encrypt(
  //     //   "my message",
  //     //   "secretkey123"
  //     // ).toString();
  //     // console.log(cipherText)
  //     // // Decrypt 解密
  //     // var bytes = CryptoJS.AES.decrypt(cipherText, "secretkey123");
  //     // var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //     // console.log(originalText); // 'my message'
  //     return this.$store.getters.userId;
  //   }
  // },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        roleId: "",
        name: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          // min: 8,
          passwordCustom: true
        }
      },
      modals: {
        content: "",
        mini: false
      }
    };
  },
  mounted() {
    let self = this;
    self.model.roleId = "0";
    if (this.$route.params.gaaId) {
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/gaa-users/${this.$route.params.gaaId}`
        )
        .then(response => {
          self.model.email = response.data.email;
          self.model.name = response.data.name;
          self.model.roleId = response.data.roleId ? response.data.roleId.toString() : "0";
          return response.data;
        })
        .catch(e => {
          if (e && e.data && e.data.message)
            this.modals.content = e.data.message;

          this.modals.mini = true;
        });
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          if (this.$route.params.gaaId) {
            // update
            return axios
              .put(
                `${process.env.VUE_APP_APIHOST}/gaa/gaa-users/${this.$route.params.gaaId}`,
                {
                  email: this.model.email,
                  name: this.model.name,
                  password: this.model.password,
                  roleId: this.model.roleId
                }
              )
              .then(response => {
                if (response && response.data && response.data.id) {
                  this.$router.push("/gaa-users");
                } else {
                  this.modals.content = "建立帳號發生錯誤";
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;

                this.modals.mini = true;
              });
          } else {
            return axios
              .post(`${process.env.VUE_APP_APIHOST}/gaa/gaa-users/`, {
                email: this.model.email,
                name: this.model.name,
                password: this.model.password,
                roleId: this.model.roleId
              })
              .then(response => {
                if (response && response.data && response.data.id) {
                  this.$router.push("/gaa-users");
                } else {
                  this.modals.content = "建立帳號發生錯誤";
                  this.modals.mini = true;
                }
                return response.data;
              })
              .catch(e => {
                if (e && e.data && e.data.message)
                  this.modals.content = e.data.message;

                this.modals.mini = true;
              });
          }
        } else {
          console.log("validate failed");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  }
};
</script>
<style>
.card .alert {
  position: relative !important;
  width: 100%;
}
</style>